import { useState } from 'react';
import Select from '@dealroadshow/uikit/core/components/Select';
import Image from '@/Framework/Router/Next/Image';
import SlickSlider from '@/Framework/UI/Molecules/SlickSlider';
import Tabs, { Tab, TabList, TabPanel } from '@dealroadshow/uikit/core/components/Tabs';
import { defaultTab, tabsContent, tabsMapping } from './constants';

import styles from './customersLogos.scss';
import cardStyles from '@dealroadshow/uikit/core/styles/card.scss';

const CustomersLogos = () => {
  const [currentTab, setCurrentTab] = useState(defaultTab);

  const onSelectChange = (selected: { value: string, label: string }) => {
    setCurrentTab(selected.value);
  };

  return (
    <div className={ styles.customersLogosContainer }>
      <div className={ cardStyles.cardContainer }>
        <div className={ styles.container }>
          <div className={ styles.customersLogosSelect }>
            <Select
              name="tabs"
              options={ tabsMapping }
              value={ { value: currentTab, label: '' } }
              onChange={ onSelectChange }
              dataTest="customersLogosSelect"
              isSearchable={ false }
            />
          </div>
        </div>
        <Tabs
          defaultTab={ currentTab }
          dataTest="customersLogosTabs"
          onChange={ setCurrentTab }
        >
          <TabList className={ styles.customersLogosTabs }>
            { tabsMapping.map((tab) => (
              <Tab
                key={ tab.value }
                tabFor={ tab.value }
                className={ styles.tab }
                name={ tab.label }
                activeClassName={ styles.isTabActive }
              >
                <span>{ tab.label }</span>
              </Tab>
            )) }
          </TabList>
          { tabsMapping.map((item) => (
            <TabPanel tabId={ item.value } key={ item.value }>
              <SlickSlider { ...tabsContent[item.value].sliderSettings }>
                {
                  tabsContent[item.value].logosConfig.map((logo) => (
                    <div
                      key={ logo.title }
                      className={ styles.customer }
                    >
                      <Image
                        src={ logo.src }
                        alt={ logo.title }
                        width={ logo.width || 115 }
                        height={ logo.height || 30 }
                      />
                    </div>
                  ))
                }
              </SlickSlider>
            </TabPanel>
          )) }
        </Tabs>
      </div>
    </div>
  );
};

export default CustomersLogos;
